import { render, staticRenderFns } from "./sTurnInProcess.vue?vue&type=template&id=c9b60e62"
import script from "./sTurnInProcess.vue?vue&type=script&lang=js"
export * from "./sTurnInProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports